var map = {
	"./asset-hyperlink.json": 1417,
	"./blockquote.json": 1418,
	"./document.json": 1419,
	"./embedded-asset-block.json": 1420,
	"./embedded-entry-block.json": 1421,
	"./embedded-entry-inline.json": 1422,
	"./embedded-resource-block.json": 1423,
	"./embedded-resource-inline.json": 1424,
	"./entry-hyperlink.json": 1425,
	"./heading-1.json": 1426,
	"./heading-2.json": 1427,
	"./heading-3.json": 1428,
	"./heading-4.json": 1429,
	"./heading-5.json": 1430,
	"./heading-6.json": 1431,
	"./hr.json": 1432,
	"./hyperlink.json": 1433,
	"./list-item.json": 1434,
	"./ordered-list.json": 1435,
	"./paragraph.json": 1436,
	"./resource-hyperlink.json": 1437,
	"./table-cell.json": 1438,
	"./table-header-cell.json": 1439,
	"./table-row.json": 1440,
	"./table.json": 1441,
	"./text.json": 1442,
	"./unordered-list.json": 1443
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1416;